import Auth from "@/services/auth"
import Http from "@/services/api/util/http-internal"
import Repo from "@/services/api/util/auth-repo-local-storage"

export default new Auth(new Repo(), new Http(), process.env.VUE_APP_BASE_URL_API)